module.exports = __webpack_public_path__ + "static/media/1-iveco.eca8ad2e.jpg";